import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';

import './i18n';
import { Provider } from 'react-redux';
import { setupStore } from './redux/store';
import { HelmetProvider } from 'react-helmet-async';
import { bootstrapClientId } from './hookServices/clientIdBootstrap';

const store = setupStore;
const domNode = document.getElementById('root');
const root = createRoot(domNode);

function renderApp() {
  root.render(
    <Provider store={store}>
      <HelmetProvider>
        <App />
      </HelmetProvider>
    </Provider>
  );
  reportWebVitals();
}

bootstrapClientId().finally(renderApp);
